import React, { useState, useEffect, useContext, useCallback } from 'react';
import { Button, Input, Select, Icon, Popover } from 'antd';
import {
  ModalBody,
  ModalContainer,
  InputLabel,
  Container,
  InputContainer,
  AddNewCategory,
  PopupContainer,
  PopupActionContainer,
  PopupLabel,
  SaveButton,
  CancelButton,
  WarningLabel,
  InputFlexColumn,
  CategoryInputLabel,
} from './styles';
import Loader from '../Loader';
import NoTeam from '../NoTeam';
import { createTemplate } from '../../utils/services/shortMessageTemplateAPI';
import { getAllCategories, createCategory } from '../../utils/services/categoriesAPI';
import { AppStoreContext } from '../../context/appStoreContext';
import { getGroupPermission } from '../../utils/services/teamsAPI';
import { CREATE_NEW_TEMPLATE_MODAL } from './translationValues';
import { withTranslation } from 'react-i18next';
import _ from 'underscore';
import { handleCommunNameCheck } from '../../utils/helper';
import { AvailableLanguagesDropdown, useSelectedTemplateLanguage } from './AvailableLanguagesDropdown';
import { isLanguageTranslationDisabled } from '../../utils/detectLanguageHelper';
import { useSessionContext } from '../../context/sessionContext';
const NAMESPACES = ['CREATE_NEW_TEMPLATE_MODAL'];

const { Option } = Select;

const CreateShortMessageTemplate = props => {
  const { onSucess, template, activeContent, t, categoryId = null, resourceGroupId = null,
   communicationId = null } = props;
  const [templateName, setTemplateName] = useState(template ? template.name : '');
  const [validTempName, setValidTempName] = useState(template?.name ? true : false);
  const [validCategName, setValidCategName] = useState(false);
  const [savingLoader, setSavingLoader] = useState(false);
  const [allCategories, setAllCategories] = useState(null);
  const [selectedCategoryId, setSelectedCategoryId] = useState(categoryId);
  const [newCategoryName, setNewCategoryName] = useState(null);
  const [savePopupVisible, setSavePopupVisible] = useState(false);
  const [savingCategory, setSavingCategory] = useState(false);
  const { userDetails, checkUserAccess } = useContext(AppStoreContext);
  const { languages, templateLanguage, setTemplateLanguage } = useSelectedTemplateLanguage();
  const [warningText, setWarningText] = useState('');
  const [allTeams, setAllTeams] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(resourceGroupId);
  const [pageLoading, setPageLoading] = useState(true);
  const [noTeam, setnoTeam] = useState(false);
  const organisationSelector = useCallback(store => store.organisationDetails, []);
  const [organisationDetails] = useSessionContext(organisationSelector);

  const userType = userDetails.userType;

  useEffect(() => {
    (async () => {
      const response = await getAllCategories(false, 'template');
      if (response && response.data) {
        let loggedUserCategory = response.data.filter(
          categoryObj => userType === categoryObj.categoryusertype,
        );
        setAllCategories(loggedUserCategory);
      }
      const teamData = await getGroupPermission(true);
      if (teamData?.data) {
        setPageLoading(false);
        if (teamData.data.length === 1) {
          setSelectedGroup(teamData.data[0].rgId);
        }
        if (teamData.length === 0) {
          setnoTeam(true);
        }
        setAllTeams(teamData.data);
      } else {
        setnoTeam(true);
        setPageLoading(false);
      }
    })();
    // eslint-disable-next-line
  }, []);

  const saveNewTemplate = () => {
    setSavingLoader(true);
    let payload;
    if (activeContent === 'sms') {
      payload = {
        name: templateName,
        voiceName: 'en-US-Wavenet-A',
        tags: '',
        categoryId: selectedCategoryId,
        resourceGroup: selectedGroup,
        communicationId: communicationId,
        call: [],
        sms: [
          {
            textValue: '',
            variableDetails: {
              isVariable: false,
              variableId: null,
              name: null,
            },
          },
        ],
        whatsapp: [],
      };
    } else if (activeContent === 'whats-app') {
      payload = {
        name: templateName,
        voiceName: 'en-US-Wavenet-A',
        tags: '',
        categoryId: selectedCategoryId,
        resourceGroup: selectedGroup,
        communicationId: communicationId,
        call: [],
        sms: [],
        whatsapp: [
          {
            textValue: '',
            variableDetails: {
              isVariable: false,
              variableId: null,
              name: null,
            },
          },
        ],
      };
    } else if (activeContent === 'call') {
      payload = {
        name: templateName,
        voiceName: 'en-US-Wavenet-A',
        tags: '',
        categoryId: selectedCategoryId,
        resourceGroup: selectedGroup,
        communicationId: communicationId,
        call: [
          {
            textValue: '',
            variableDetails: {
              isVariable: false,
              variableId: null,
              name: null,
            },
          },
        ],
        sms: [],
        whatsapp: [],
      };
    } else {
      payload = {
        name: templateName,
        voiceName: 'en-US-Wavenet-A',
        tags: '',
        categoryId: selectedCategoryId,
        resourceGroup: selectedGroup,
        communicationId: communicationId,
        call: [],
        sms: [],
        whatsapp: [],
      };
    }
    if (isLanguageTranslationDisabled(organisationDetails) && templateLanguage) {
      payload.language = templateLanguage;
    }
    createNewTemplate(payload);
  };

  const createNewTemplate = async payload => {
    let templateResponse = await createTemplate(payload);
    if (templateResponse && templateResponse.errors && templateResponse.errors.length === 0) {
      let savedTemplateDetails = payload;
      savedTemplateDetails.id = templateResponse.id;
      const categoryIndex = allCategories.findIndex(
        categoryDetails => categoryDetails.id === parseInt(payload.categoryId),
      );
      let categoryUpdates = {
        categoryDetails: allCategories[categoryIndex],
        savedTemplate: payload,
      };
      categoryUpdates.categoryDetails.categoryId = allCategories[categoryIndex].id;
      categoryUpdates.categoryDetails.categoryName = allCategories[categoryIndex].name;
      setSavingLoader(false);
      onSucess(templateResponse, 'saveCategoryTemplate', categoryUpdates);
    } else {
      setSavingLoader(false);
    }
  };

  const setCategoryName = categoryName => {
    setNewCategoryName(categoryName.trimStart());
    if (categoryName.split(' ').join('').length) {
      setValidCategName(true);
    } else {
      setValidCategName(false);
    }
  };

  const handlePopupVisibleChange = visible => {
    setSavePopupVisible(visible);
  };

  const saveNewCategory = () => {
    setSavingCategory(true);
    let payload = {
      name: newCategoryName,
      type: 'template',
    };
    createNewCategory(payload);
  };

  const createNewCategory = async payload => {
    let categoryResponse = await createCategory(payload);
    if (categoryResponse && categoryResponse.errors && categoryResponse.errors.length === 0) {
      const savedCategory = {
        createdBy: null,
        createdOn: null,
        elements: null,
        id: categoryResponse.id,
        name: payload.name,
        parentId: 0,
        status: 'active',
        type: 'template',
        updatedBy: null,
        updatedOn: null,
      };
      setAllCategories(allCategories => [...allCategories, savedCategory]);
      setSavePopupVisible(false);
      setSelectedCategoryId(categoryResponse.id);
      setNewCategoryName(null);
      setSavingCategory(false);
    } else {
      setSavingCategory(false);
    }
  };

  const debouncedNameCheck = useCallback(
    _.debounce(async (name) => {
      const nameCheck = await handleCommunNameCheck(name);
      if (nameCheck.length > 0) {
        setValidTempName(false)
        name !== "" && setWarningText(t(CREATE_NEW_TEMPLATE_MODAL.COMMUNICATION_NAME_VALIDATION.key, CREATE_NEW_TEMPLATE_MODAL.COMMUNICATION_NAME_VALIDATION.value));
      } else {
        setValidTempName(true)
        setWarningText('');
      }
    }, 500),
    []
  );

  const changeTempName = name => {
    setTemplateName(name.trimStart());
    if (name.split(' ').join('').length) {
      setWarningText('');
      setValidTempName(true);
    }
    else {
      setWarningText(t(CREATE_NEW_TEMPLATE_MODAL.ENTER_VALID_TEMPLATE_NAME_WARNING_MESSAGE.key, CREATE_NEW_TEMPLATE_MODAL.ENTER_VALID_TEMPLATE_NAME_WARNING_MESSAGE.value));
      setValidTempName(false);
    }
    debouncedNameCheck(name);
  };

  return (
    <Container onKeyDown={e => e.stopPropagation()}>
      <ModalBody>
        <ModalContainer>
          {pageLoading ? (
            <Loader />
          ) : noTeam ? (
            <NoTeam />
          ) : (
            <>
              <InputContainer>
                <InputLabel>{t(CREATE_NEW_TEMPLATE_MODAL.TEMPLATE_NAME_LABEL.key, CREATE_NEW_TEMPLATE_MODAL.TEMPLATE_NAME_LABEL.value)}</InputLabel>
                <Input
                  placeholder={t(CREATE_NEW_TEMPLATE_MODAL.TEMPLATE_NAME_PLACEHOLDER.key, CREATE_NEW_TEMPLATE_MODAL.TEMPLATE_NAME_PLACEHOLDER.value)}
                  autoComplete="off"
                  name="templateName"
                  onChange={e => {
                    changeTempName(e.target.value);
                  }}
                  size="large"
                  value={templateName}
                  disabled={communicationId !== null}
                />
                {warningText && <WarningLabel>{warningText}</WarningLabel>}
              </InputContainer>
              <InputContainer>
                <InputFlexColumn>
                  <AddNewCategory>
                  <CategoryInputLabel>{t(CREATE_NEW_TEMPLATE_MODAL.CATEGORY_NAME_LABEL.key, CREATE_NEW_TEMPLATE_MODAL.CATEGORY_NAME_LABEL.value)}</CategoryInputLabel>
                    <Popover
                      content={
                        <PopupContainer>
                          <PopupLabel>{t(CREATE_NEW_TEMPLATE_MODAL.CATEGORY_NAME_LABEL.key, CREATE_NEW_TEMPLATE_MODAL.CATEGORY_NAME_LABEL.value)}</PopupLabel>
                          <Input
                            placeholder={t(CREATE_NEW_TEMPLATE_MODAL.CATEGORY_NAME_PLACEHOLDER.key, CREATE_NEW_TEMPLATE_MODAL.CATEGORY_NAME_PLACEHOLDER.value)}
                            autoComplete="off"
                            name="categoryName"
                            value={newCategoryName}
                            onChange={e => setCategoryName(e.target.value)}
                          />
                          <PopupActionContainer>
                            <CancelButton
                              size="default"
                              onClick={() => handlePopupVisibleChange(false)}
                            >
                              {t(CREATE_NEW_TEMPLATE_MODAL.CANCEL_BUTTON.key, CREATE_NEW_TEMPLATE_MODAL.CANCEL_BUTTON.value)}
                            </CancelButton>
                            <SaveButton
                              type="primary"
                              size="default"
                              onClick={() => saveNewCategory()}
                              disabled={!newCategoryName || !validCategName}
                              loading={savingCategory}
                            >
                              {savingCategory ? t(CREATE_NEW_TEMPLATE_MODAL.SAVING_CATEGORY_LOADING_TEXT.key, CREATE_NEW_TEMPLATE_MODAL.SAVING_CATEGORY_LOADING_TEXT.value) : t(CREATE_NEW_TEMPLATE_MODAL.SAVE_BUTTON.key, CREATE_NEW_TEMPLATE_MODAL.SAVE_BUTTON.value)}
                            </SaveButton>
                          </PopupActionContainer>
                        </PopupContainer>
                      }
                      placement="leftBottom"
                      trigger="click"
                      visible={savePopupVisible}
                      onVisibleChange={handlePopupVisibleChange}
                    >
                      <Icon type="plus" />  {t(CREATE_NEW_TEMPLATE_MODAL.ADD_NEW_ACTION.key, CREATE_NEW_TEMPLATE_MODAL.ADD_NEW_ACTION.value)}
                    </Popover>
                  </AddNewCategory>
                  <Select
                    loading={!allCategories}
                    showSearch
                    placeholder={t(CREATE_NEW_TEMPLATE_MODAL.CATEGORY_NAME_PLACEHOLDER.key, CREATE_NEW_TEMPLATE_MODAL.CATEGORY_NAME_PLACEHOLDER.value)}
                    optionFilterProp="children"
                    value={selectedCategoryId ? selectedCategoryId : undefined}
                    onChange={value => setSelectedCategoryId(value)}
                    filterOption={(input, option) =>
                      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {allCategories &&
                      allCategories.map(data => {
                        return (
                          <Option key={String(data.id)} value={data.id}>
                            {data.name}
                          </Option>
                        );
                      })}
                  </Select>
                </InputFlexColumn>
              </InputContainer>

              {allTeams.length > 1 && (
                <InputContainer>
                  <InputLabel>{t(CREATE_NEW_TEMPLATE_MODAL.SELECT_TEAM_LABEL.key, CREATE_NEW_TEMPLATE_MODAL.SELECT_TEAM_LABEL.value)}</InputLabel>
                  <Select
                    loading={!allTeams}
                    showSearch
                    placeholder={t(CREATE_NEW_TEMPLATE_MODAL.SELECT_TEAM_PLACEHOLDER.key, CREATE_NEW_TEMPLATE_MODAL.SELECT_TEAM_PLACEHOLDER.value)}
                    optionFilterProp="children"
                    value={selectedGroup || undefined}
                    onChange={value => setSelectedGroup(value)}
                    filterOption={(input, option) =>
                      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {allTeams &&
                      allTeams.map(data => {
                        return (
                          <Option key={String(data.id)} value={data.rgId}>
                            {data.groupName}
                          </Option>
                        );
                      })}
                  </Select>
                </InputContainer>
              )}
              <AvailableLanguagesDropdown
                languages={languages}
                templateLanguage={templateLanguage}
                setTemplateLanguage={setTemplateLanguage}
              />
              <InputContainer>
                <div className="form_btn">
                  <Button
                    key="submit"
                    type="primary"
                    disabled={!templateName || !validTempName || !selectedCategoryId || (checkUserAccess('client') && !selectedGroup)}
                    loading={savingLoader}
                    onClick={() => saveNewTemplate()}
                  >
                    {savingLoader ? t(CREATE_NEW_TEMPLATE_MODAL.START_DESIGN_BUTTON.key, CREATE_NEW_TEMPLATE_MODAL.START_DESIGN_BUTTON.value) : t(CREATE_NEW_TEMPLATE_MODAL.START_DESIGN_BUTTON.key, CREATE_NEW_TEMPLATE_MODAL.START_DESIGN_BUTTON.value)}
                  </Button>
                </div>
              </InputContainer>
            </>
          )}
        </ModalContainer>
      </ModalBody>
    </Container>
  );
};
export default withTranslation(NAMESPACES)(CreateShortMessageTemplate);
